var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-search",
    clipPath: "url(#clip0_1624_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8421 14.9158L11.6387 10.7124C13.068 8.95554 13.4908 6.58703 12.7585 4.44436C12.0262 2.3017 10.2422 0.686762 8.03709 0.17206C5.832 -0.342684 3.51679 0.314909 1.91173 1.91169C0.314935 3.51668 -0.342744 5.83175 0.172105 8.03704C0.686849 10.2421 2.30174 12.026 4.44441 12.7585C6.58707 13.4908 8.95567 13.068 10.7125 11.6387L14.9158 15.842C15.1761 16.0653 15.5652 16.0506 15.8074 15.8076C16.0504 15.5654 16.0652 15.1762 15.8419 14.916L15.8421 14.9158ZM2.83792 10.2723C1.85194 9.28717 1.29779 7.9506 1.29779 6.55655C1.29779 5.16337 1.85112 3.82689 2.83628 2.84078C3.82145 1.85561 5.15801 1.30146 6.55206 1.30146C7.9461 1.30146 9.28256 1.85561 10.2678 2.84078C11.253 3.82676 11.8063 5.16335 11.8063 6.55655C11.8063 7.95056 11.2522 9.28706 10.2662 10.2723C9.28513 11.2649 7.94783 11.824 6.5521 11.824C5.15637 11.824 3.81899 11.2649 2.83792 10.2723Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1624_1128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSearch);
export default __webpack_public_path__ + "static/media/icn_search.5bb79c5b8badd4926980013c0507bd0c.svg";
export { ForwardRef as ReactComponent };